import amapi from '@/api/amapi'
import { getCookie, setCookie, removeCookie } from 'tiny-cookie'

const initialState = () => ({
  loadingMigrations: true,
  migrations: [],
  migrationsDetails: [],
  hiddenMigrationAlerts: [],
})

const state = initialState

const getters = {
  loadingMigrations: state => state.loadingMigrations,
  migrations: state => state.migrations,
  fullMigrations: state => state.migrationsDetails,
  hiddenMigrationAlerts: state => state.hiddenMigrationAlerts,
}

const mutations = {
  SET_LOADING_MIGRATIONS (state, loading) {
    state.loadingMigrations = loading
  },
  SET_MIGRATIONS (state, migrations) {
    state.migrations = migrations
  },
  SET_HIDDEN_MIGRATIONS (state, hiddenMigrations) {
    state.hiddenMigrationAlerts = hiddenMigrations
  },
  ADD_HIDDEN_MIGRATION (state, hiddenMigration) {
    state.hiddenMigrationAlerts.push(hiddenMigration)
  },
  ADD_MIGRATION_DETAILS (state, migration, replaceId) {
    let replaceIdx = state.migrationsDetails.findIndex(migration => migration.id == replaceId)
    if (replaceIdx === -1) {
      replaceIdx = state.migrationsDetails.length
    }
    state.migrationsDetails.splice(replaceIdx - 1, 1, migration)
  },
}

const actions = {
  async getMigrations ({ commit }) {
    commit('SET_LOADING_MIGRATIONS', true)
    try {
      const response = await amapi.makecall('migration_list')
      const migrations = Array.isArray(response.migrations) ? response.migrations : []
      commit('SET_MIGRATIONS', migrations)
    } catch (e) {
      // errors handled in the places where the actions are called
      throw e
    } finally {
      commit('SET_LOADING_MIGRATIONS', false)
    }
  },
  async getMigration ({ commit, state }, id, noCache = true) {
    const cachedMigration = state.migrationsDetails.find((migration) => {
      return migration.id == id
    })
    if (cachedMigration && !noCache) {
      return cachedMigration
    }
    const response = await amapi.makecall('migration_view', { id })
    commit('ADD_MIGRATION_DETAILS', response.migration, cachedMigration?.id)
    return response.migration
  },
  hideMigrationAlert ({ commit, dispatch }, migrationId) {
    commit('ADD_HIDDEN_MIGRATION', migrationId)
    dispatch('saveHiddenMigrations')
  },
  initHiddenMigrations ({ commit }) {
    const parsed = JSON.parse(getCookie('hiddenMigrations'))
    const storedHiddenMigrations = Array.isArray(parsed) ? parsed : []
    commit('SET_HIDDEN_MIGRATIONS', storedHiddenMigrations)
  },
  saveHiddenMigrations ({ state }) {
    if (!state.hiddenMigrationAlerts.length) {
      removeCookie('hiddenMigrations')
      return
    }
    const strMigrations = JSON.stringify(state.hiddenMigrationAlerts)
    setCookie('hiddenMigrations', strMigrations, { expires: '1Y' })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
